module.exports = "https://static.wmbcdn.com/uniweb/images/3f57754c1833a711b6929fc7fe61fff3.svg";